import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IAccountingDistributionExternal, PermissionsService } from '../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromAccountingDistributionExternal from './state/accounting-distribution-external.selectors';
import * as AccountingDistributionExternalAction from './state/accounting-distribution-external.actions';
import * as lgeApp from '../../app/state/app.actions';
import { Observable, skipWhile, Subscription } from 'rxjs';

@Component({
    selector: 'accounting-distribution-external-screen',
    templateUrl: 'accounting-distribution-external.component.html',
    styleUrls: ['accounting-distribution-external.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingDistributionExternalScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IAccountingDistributionExternal | null>;
    stateDataSubscription: Subscription;
    stateData: IAccountingDistributionExternal | null;

    constructor(
        private store: Store<fromAccountingDistributionExternal.State>, 
        private ref: ChangeDetectorRef,
        private fb: FormBuilder, 
        private ams: AngularMaterialService,
        private permissionsService: PermissionsService,
        private errorParse: ErrorParseService
    ) {
        this.selectState();
        this.createForms();
    }


    ngOnInit() {
        this.startSubscriptions();
    }

    // Select state
    private selectState(): void {
            this.pending$ = this.store.select(fromAccountingDistributionExternal.getAccountingDistributionExternalScreenPending);
            this.stateData$ = this.store.select(fromAccountingDistributionExternal.getAccountingDistributionExternalState);
            this.error$ = this.store.select(fromAccountingDistributionExternal.getAccountingDistributionExternalScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
          setTimeout(() => {
              this.ams.showLoader('Loading...');
              this.ref.markForCheck();
          })
        } else {
          this.ams.closeDialog().then(() => {
            if (this.error !== null && this.error !== undefined && this.error !== '') {
              this.displayError(this.error);
            }
          });
        }
      }
    
      displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
          errorMessage = this.errorParse.translateCCError(error);
        } else {
          errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
          this.store.dispatch(new AccountingDistributionExternalAction.AccountingDistributionExternalScreenErrorReset());
        });
      }
        
    // Create reactive forms
    createForms(): void {

    }
    hasRole(role: string) {
        return this.permissionsService.hasRoles(role);
    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
        .subscribe(data => {
            this.pending = data;
            this.displayLoader(this.pending);
            this.ref.markForCheck();
        });
        this.errorSubscription = this.error$
        .subscribe(data => {
            this.error = data;
            this.ref.markForCheck();
        });
        this.stateDataSubscription = this.stateData$
        .subscribe(data => {
            this.stateData = data;
            this.ref.markForCheck();
        });   
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }
  
    ngOnDestroy() {
        this.endSubscriptions();
    }
    

}